import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal",
  id: "app__modal"
}
const _hoisted_2 = {
  key: 0,
  class: "modal__content"
}
const _hoisted_3 = { class: "modal__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isViewport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            class: "modal__close",
            name: "modal-close",
            onClick: _withModifiers(_ctx.close, ["prevent"])
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_3, [
            (!(_ctx.isSuccess || _ctx.isError))
              ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
              : (_ctx.isError)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_Icon, {
                      class: "modal__icon",
                      name: "error"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal__title" }, "Ошибка отправки", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal__subtitle" }, " Что-то пошло не так. Пожалуйста, повторите попытку позже ", -1)),
                    _createVNode(_component_Button, {
                      size: "helike",
                      skin: "secondary",
                      "is-wide": "",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.nullForm()), ["prevent"]))
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("Повторить")
                      ])),
                      _: 1
                    })
                  ], 64))
                : (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_Icon, {
                        class: "modal__icon",
                        name: "success"
                      }),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal__title" }, "Заявка отправлена", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal__subtitle" }, " Наш менеджер свяжется с вами, чтобы обсудить детали и договориться об удобном времени ", -1)),
                      _createVNode(_component_Button, {
                        size: "helike",
                        skin: "secondary",
                        "is-wide": "",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"]))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Хорошо")
                        ])),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
          ])
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ]))
}